@if (serving) {
    <div class="column serving">
        <div class="cell">
            @if (score?.currentlyServing === 1) {
                <span class="serving-indicator"></span>
            }
        </div>
        <div class="cell">
            @if (score?.currentlyServing === 2) {
                <span class="serving-indicator"></span>
            }
        </div>
    </div>
}

@if (score && score.participant1 !== undefined && score.participant2 !== undefined) {
    <div class="column score" [class.show-score-right]="showRedcards">
        <div class="cell" [ngClass]="{ 'goal-blinker': goalParticipant1() }">
            @if (goalParticipant1()) {
                <ng-container *ngTemplateOutlet="goalAnimation" />
            }
            <div [msValueSlider]="score.participant1.toString()"></div>
        </div>
        <div class="cell" [ngClass]="{ 'goal-blinker': goalParticipant2() }">
            @if (goalParticipant2()) {
                <ng-container *ngTemplateOutlet="goalAnimation" />
            }
            <div [msValueSlider]="score.participant2.toString()"></div>
        </div>
    </div>
    <ng-template #goalAnimation>
        <div class="goal-indicator">
            <span class="inner">{{ sitecore.eventGrid.GoalText }}</span
            ><i class="sport-icon sports-{{ event.sport.id }}"></i>
        </div>
    </ng-template>
}

@if (statistics) {
    <ng-container *msShowInEpcot="{ showInEpcot: false, module: module }">
        <div class="column stats">
            @for (i of [0, 1]; track i) {
                <div class="cell">
                    @if (yellowCards[i] && !recentGoalScored()) {
                        <div class="yellow card">
                            <span>{{ yellowCards[i] }}</span>
                        </div>
                    }
                    @if (redCards[i] && !recentGoalScored()) {
                        <div class="red" [class.card]="hasExtended">
                            <span [class.red-card-count]="showRedcards">{{ redCards[i] }}</span>
                        </div>
                    }
                </div>
            }
        </div>
    </ng-container>
}
